import { render, staticRenderFns } from "./NuxtSource.vue?vue&type=template&id=9cbb8faa&"
import script from "./NuxtSource.vue?vue&type=script&lang=js&"
export * from "./NuxtSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports